import React, { useContext, useEffect, useState } from 'react'
import styles from '../styles.module.css'
import modalStyles from './styles.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import Button from '../../../../components/Button'
import Modal from 'react-responsive-modal'
import { useFormik } from 'formik'
import { Input, Select } from '../../../../components/ModalInputs'
import Confirmation from '../../../../components/Confirmation/Confirmation'
import { BiTrash } from 'react-icons/bi'
import Table from '../../../../components/Table'
import { StaffRosterContext } from '../../../../utils/context'
import { createAttestationforPersonnel, getAttestationforPersonnel } from '../../../../actions/personnel/personnel'

// Mock данные для категорий
const categories = [
  { name: '', value: '' },
  { name: 'Высшая категория', value: 'highest' },
  { name: 'Первая категория', value: 'first' },
  { name: 'Соответствие занимаемой должности', value: 'compliance' },
  { name: 'Без категории', value: 'none' }
]

// Mock данные для решений комиссии
const decisions = [
  { name: '', value: '' },
  { name: 'Присвоить категорию', value: 'assign' },
  { name: 'Подтвердить категорию', value: 'confirm' },
  { name: 'Отказать в присвоении', value: 'reject' },
  { name: 'Соответствует занимаемой должности', value: 'compliant' }
]



const Attestation = () => {

  const dispatch = useDispatch()
  const { allForms, addMode, } = useContext(StaffRosterContext)
  const { values, errors, handleSubmit, handleChange, setValues, setFieldValue } = allForms || {}
  const { mid } = values || {}

  const { personnelAttestationsList } = useSelector(state => state.personnel)

  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(null)
  const [select, setSelect] = useState(null)

  const deleteItem = (id) => (e) => {
    e.stopPropagation()
    setConfirmation(id)
  }

  const openModal = (data) => () => setSelectedItem(data || {})

  const closeModal = () => setSelectedItem(null)

  const handleSelect = (item) => {
    const isSelected = select?.xp_key === item.xp_key
    setSelect(isSelected ? null : item)
  }

  const acceptConfirmation = () => {
    // dispatch(deleteEventLevel(confirmation))
    setConfirmation(null)
  }

  const rejectConfirmation = () => {
    setConfirmation(null)
  }
  const renderLi = (item) => {
    const { doctext, category, date, docdate, docnumber, result, xp_key } = item
    const isSelected = select?.xp_key === xp_key
    return (
      <tr
        key={xp_key}
        onClick={() => handleSelect(item)}
        className={isSelected ? styles.selectedRow : ''}
      >
        <td>{date}</td>
        <td>{category}</td>
        <td>{result}</td>
        <td>{docnumber}</td>
        <td>{docdate}</td>
        <td>{doctext}</td>
        <td>
          <BiTrash
            size={20}
            color='red'
            title='Удалить'
            onClick={deleteItem(xp_key)}
            style={{ cursor: 'pointer' }}
          />
        </td>
      </tr>
    )
  }

  return (
    <div className={styles.tabWrapper}>
      {/* Таблица */}
      <div className={styles.qualificationTableSection}>
        <Table>
          <thead>
            <tr>
              <th>Дата аттестации</th>
              <th>Категория</th>
              <th>Решение комиссии</th>
              <th>Номер документа</th>
              <th>Дата документа</th>
              <th>Основание документа</th>
              <th>Удалить</th>
            </tr>
          </thead>
          <tbody>
            {personnelAttestationsList?.length > 0 && typeof personnelAttestationsList !== 'string' ? (
              personnelAttestationsList?.map(renderLi)
            ) : (
              <tr>
                <td colSpan="7" className={styles.emptyTable}>
                  Нет данных об аттестации
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {/* Кнопки */}
      <div className={styles.qualificationForm}>
        <div className={styles.inputsRow}>
          <div className={styles.qualificationButtonsInline}>
            <Button onClick={openModal()}>+ Добавить</Button>
          </div>
        </div>
      </div>
      <ModalComponent
        open={!!selectedItem}
        closeModal={closeModal}
        data={selectedItem}
        addMode={!selectedItem?.news_level_id}
        mid={mid}
      />
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title="Уверены что хотите удалить запись?"
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
    </div>
  )
}


const ModalComponent = ({ open, closeModal, data, addMode, mid }) => {

  const dispatch = useDispatch()

  const createItem = async (values) => {
    const success = await dispatch(createAttestationforPersonnel({ mid, ...values }))
    success && closeModal()
  }

  const updateItem = async ({ news_level_id, ...values }) => {
    // const success = await dispatch(updateEventLevel(news_level_id, values))
    // success && closeModal()
  }

  const {
    values,
    errors,
    handleSubmit,
    handleChange,
    setValues,
    setFieldValue
  } = useFormik({
    initialValues: addMode ? {} : data,
    enableReinitialize: true,
    onSubmit: addMode ? createItem : updateItem
  })

  const renderOptions = ({ name, value }) => <option key={value || 'empty'} value={value}>{name}</option>

  return (
    <Modal
      open={open}
      onClose={closeModal}
      classNames={{ modal: modalStyles.modal }}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      showCloseIcon={false}
      animationDuration={2}
      center
    >
      <div className={modalStyles.modalMain}>
        <h2>{addMode ? 'Добавление записи' : 'Редактирование записи'}</h2>
        <div className={modalStyles.inputsRow}>
          <Input
            label='Дата аттестации'
            name='date'
            type='date'
            value={values?.date}
            onChange={handleChange}
          />
          <Select
            name='category'
            label='Категория'
            value={values?.category}
            onChange={handleChange}
          >
            {categories.map(renderOptions)}
          </Select>
          <Select
            name='result'
            label='Решение комиссии'
            value={values?.result}
            onChange={handleChange}
          >
            {decisions.map(renderOptions)}
          </Select>
        </div>
        <div className={modalStyles.inputsRow}>
          <Input
            name='docnumber'
            label='Номер документа'
            value={values?.docnumber}
            onChange={handleChange}
          />
          <Input
            label='Дата документа'
            name='docdate'
            type='date'
            value={values?.docdate}
            onChange={handleChange}
          />
          <Input
            name='doctext'
            label='Основание документа'
            value={values?.doctext}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className={modalStyles.modalFooter}>
        <div>
          <div></div>
          <div></div>
        </div>
        <Button mode='white' type="submit" onClick={handleSubmit}>Сохранить</Button>
        <Button mode='white' onClick={closeModal}>Закрыть</Button>
      </div>
    </Modal>
  )
}


export default Attestation